// extracted by mini-css-extract-plugin
module.exports = {"dropdown-width":"GaTemplate-module__dropdown-width__1A-bL","root":"GaTemplate-module__root__19jGQ"};